import React from 'react'
import { Stack, Text, Select, Group, Skeleton } from 'components'
import { useTranslation } from 'react-i18next'
import { GradeLevel } from '../../../types'

interface GradeLevelSectionProps {
  gradeLevels: GradeLevel[]
  value: string | null
  onChange: (value: string | null) => void
  loading?: boolean
  error?: boolean
}

export const GradeLevelSection: React.FC<GradeLevelSectionProps> = ({
  gradeLevels,
  value,
  onChange,
  loading,
  error
}) => {
  const { t } = useTranslation()

  // Filter data for Select to avoid passing extra props to DOM
  const selectData = gradeLevels.map(({ value, label }) => ({ value, label }))

  return (
    <Stack spacing="md">
      <div>
        <Group spacing="xs" mb="0">
          <Text size="lg" weight={500}>
            {t('arc_grade_level_question')}
            <Text color="red" display="inline"> *</Text>
          </Text>
        </Group>
        <Text size="lg" color="dimmed" mb="sm">
          {t('arc_choose_grade_designed')}
        </Text>

        {loading ? (
          <Skeleton height={42} radius="md" />
        ) : (
          <Select
            size="lg"
            placeholder={t('arc_select_grade_level')}
            data={selectData}
            value={value}
            onChange={onChange}
            required
            searchable
            nothingFound={t('arc_no_options')}
            error={error}
          />
        )}

        {error && (
          <Text size="sm" color="red" mt={4}>
            {t('arc_field_required')}
          </Text>
        )}
      </div>
    </Stack>
  )
}